import React from 'react';
import { HeroSection } from './HeroSection';
import { PlayerSection } from './PlayerSection';
import { ExplainSection } from './ExplainSection';
import { MessageSection } from './MessageSection';
import { FeaturesSection } from './FeaturesSection';
import { DonationSection } from './DonationSection';
import { FooterSection } from './FooterSection';

/**
 * MainSections Container
 * Orchestrates all scroll sections
 */
export function MainSections({ currentSection, scrollProgress, isAnalyzerActive, isStreamLoading, isStreamOffline, currentTrack, isPKIActive, pkiCurrentQuestion, pkiCompleted, currentProfileId, mode, onModeChange, onPlayClick, onPKIComplete, onPKIQuestionChange, onJoinStream, backgroundColor }) {
  return (
    <div className="relative z-20">
      {/* Section 0: Hero/Title */}
      <HeroSection scrollProgress={scrollProgress} />

      {/* Section 1: Player/Analyzer */}
      <PlayerSection
        currentSection={currentSection}
        scrollProgress={scrollProgress}
        isAnalyzerActive={isAnalyzerActive}
        isStreamLoading={isStreamLoading}
        isStreamOffline={isStreamOffline}
        currentTrack={currentTrack}
        isPKIActive={isPKIActive}
        pkiCurrentQuestion={pkiCurrentQuestion}
        pkiCompleted={pkiCompleted}
        currentProfileId={currentProfileId}
        mode={mode}
        onModeChange={onModeChange}
        onPlayClick={onPlayClick}
        onPKIComplete={onPKIComplete}
        onPKIQuestionChange={onPKIQuestionChange}
        onJoinStream={onJoinStream}
      />

      {/* Section 2: Explain */}
      <ExplainSection backgroundColor={backgroundColor} />

      {/* Section 3: Message */}
      <MessageSection />

      {/* Section 3: Features/BentoGrid */}
      <FeaturesSection backgroundColor={backgroundColor} />

      {/* Section 4: Donation */}
      <DonationSection backgroundColor={backgroundColor} />

      {/* Section 5: Footer */}
      <FooterSection backgroundColor={backgroundColor} />
    </div>
  );
}
